import React from 'react';
import { TouchableOpacity, Image, Text } from "react-native";
import get from "../../../api/methods/get";
import post from "../../../api/methods/post";
import Colors from "../../../constants/Colors";

class LikeIndicator extends React.Component {

    state = {
        numberOfLikes: 0,
        userCanLike: false,
        checkingIfUserCanLike: false,

        sendingLike: false,
        removingLike: false,
    }

    sendLike = async () => {

        const { endpointToSendLike, payloadToAddLike } = this.props;

        if (this.state.sendingLike) return;
        this.setState({ sendingLike: true, numberOfLikes: this.state.numberOfLikes + 1 });

        try {
            let result = await post(endpointToSendLike, payloadToAddLike);
            let json = await result.json();
            this.setState({ userCanLike: false, numberOfLikes: json.data.numberOfLikes });

        } catch (e) {
            console.log(e);
        }

        this.setState({ sendingLike: false });

    }

    removeLike = async () => {
        if (this.state.removingLike) return;
        this.setState({ removingLike: true });

        try {

            const { endpointToRemoveLike, payloadToRemoveLike } = this.props;
            let result = await post(endpointToRemoveLike, payloadToRemoveLike);
            let json = await result.json();
            this.setState({ userCanLike: true, numberOfLikes: json.data.numberOfLikes });

        } catch (e) {
            console.log(e);
        }

        this.setState({ removingLike: false });

    }

    checkForUserLike = async () => {
        const { endpointToCheckForLike } = this.props;

        if (this.state.checkingIfUserCanLike === true) return;
        this.setState({ checkingIfUserCanLike: true })

        try {
            let result = await get(endpointToCheckForLike);
            let json = await result.json();

            this.setState({ userCanLike: json.data.canLike })
        } catch (e) {
            console.log(e);
        }

        this.setState({ checkingIfUserCanLike: false })

    }

    componentDidMount() {
        this.checkForUserLike()
        this.setState({ numberOfLikes: this.props.numberOfLikes })
    }

    render() {

        const { checkingIfUserCanLike, sendingLike, removingLike } = this.state;

        let canLike = this.state.userCanLike;
        if (this.state.checkingIfUserCanLike)
            canLike = true;


        let canClick = !(checkingIfUserCanLike === false && sendingLike === false  && removingLike === false);

        const source = canLike === true ?
            require('../img/hearth/HeartIconEmpty.png') :
            require('../img/hearth/HeartIcon.png')

        const color = canLike === true ? Colors.fontColorOnBackground :  "red"

        return (
            <TouchableOpacity
                onPress={() => {
                    if (canLike)
                        this.sendLike()
                    else
                        this.removeLike()
                }}
                style={{ flexDirection: 'row' }}
            >

                <Image
                    source={source}
                    style={{ height: 16, width: 16, marginRight: 6, tintColor: color }}
                    resizeMode={'contain'}
                />

                <Text style={{ color: Colors.fontColorOnBackground, fontSize: 12, }}>
                    { this.state.numberOfLikes }
                </Text>

            </TouchableOpacity>
        )
    }


}

export default LikeIndicator;

